import React, { useEffect, useRef, useState } from 'react'
import { CFormLabel, CFormInput, CButton, CTable, CTableBody, CTableHead, CTableHeaderCell, CTableRow, CTableDataCell, CModal, CModalHeader, CModalBody, CModalFooter, CModalTitle, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from '@coreui/react'
import Select from 'react-select'
import MedicineCRUD from '../../services/general/Medication.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import CreatableSelect from 'react-select/creatable'
import { EllipsisVertical } from 'lucide-react'
import SaveExtra from '../../services/general/saveExtraData.api'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Diagnosis from './Diagnosis'
import pdfToText from 'react-pdftotext'
import HighlightedText from '../../components/shared/HighlightedText'
import SaveTasks from '../../services/general/TaskCrud.api'
import SaveBoard from '../../services/general/BoardCrud.api'

const frequencyMedicationOptions = [

  { label: 'BID', value: 'BID' },
  { label: 'TID', value: 'TID' },
  { label: 'PID', value: 'PID' },
  { label: 'QID', value: 'QID' },

]

const selectMenuStyles = {
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
}

const AddMedicationForm = ({
  medicationList,
  handleAddDetectedToMedListInModal,
  newMedications,
  setNewMedications,
  textFile,
  setTextFile,
  editMedicationBundleListDateId,
  handleSaveMedications,
  setEditMedicationBundleListDateId,
  handleOnCancelAddingFinalMedication,
  addMedicationToList,
  setMedicationList,
  setModalVisible,
  modalVisible,
  patientID,
  patientName,
  facilityName,
  roomNumber,
  appoinmentDate,
  noteID,
}) => {
  const [medicationName, setMedicationName] = useState('')
  const [dosage, setDosage] = useState('')
  const [route, setRoute] = useState('')
  const [frequency, setFrequency] = useState('')
  const [medicationOptions, setMedicationOptions] = useState([])
  const [selectedMedication, setSelectedMedication] = useState(null)
  const [allMedications, setAllMedications] = useState([])
  const [drugIntervationsSelectedMedication, setDrugIntervationsSelectedMedication] = useState([])
  const [showDrugIntervationsModal, setShowDrugIntervationsModal] = useState(false)
  const [isEditMedicationAddedIndex, setIsEditMedicationAddedIndex] = useState(null)
  const [selectedOption, setSelectedOption] = useState(null)
  const [dosageOption, setDosageOption] = useState([])
  const [selectDosageName, setSelectedDosageName] = useState(null)
  const [compareMedication, setCompareMedication] = useState([])
  const [diagnosisData, setDiagnosisData] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState([])
  const [addingFile, setAddingFile] = useState(false)
  const [pendingSpecialtyMedications, setPendingSpecialtyMedications] = useState([])

  const resolveMasterMedication = (medicationLike = selectedMedication) => {
    if (!medicationLike) return null

    if (typeof medicationLike === 'object' && medicationLike.name) {
      const matchedMedication = allMedications.find((med) => med.name?.trim()?.toLowerCase() === medicationLike.name?.trim()?.toLowerCase())
      return matchedMedication || medicationLike
    }

    const normalizedName = String(medicationLike || '').trim().toLowerCase()
    return allMedications.find((med) => med.name?.trim()?.toLowerCase() === normalizedName) || null
  }

  const getLoggedInUserDetails = () => {
    let loginUserId = ''
    let loginUsername = ''

    try {
      const userData = localStorage.getItem('user')
      const userLoginData = localStorage.getItem('userLoginWithCredentials')

      if (userData) {
        const parsedUser = JSON.parse(userData)
        loginUserId = parsedUser?.Id || parsedUser?.UserID || parsedUser?.UserId || parsedUser?.id || ''
        loginUsername =
          parsedUser?.Username ||
          parsedUser?.username ||
          parsedUser?.UserName ||
          parsedUser?.Name ||
          parsedUser?.name ||
          parsedUser?.Email ||
          parsedUser?.email ||
          ''
      }

      if (userLoginData) {
        const parsedLogin = JSON.parse(userLoginData)
        loginUsername =
          loginUsername ||
          parsedLogin?.username ||
          parsedLogin?.Username ||
          parsedLogin?.phoneNo ||
          ''
      }
    } catch (error) {
      console.error('Failed to load logged in user details for specialty medication task:', error)
    }

    return {
      loginUserId: String(loginUserId || ''),
      loginUsername: String(loginUsername || ''),
    }
  }

  const createSpecialtyMedicationTask = async (medicationEntries = []) => {
    const specialtyMedicationEntries = (Array.isArray(medicationEntries) ? medicationEntries : [medicationEntries])
      .filter(Boolean)
      .filter((medicationEntry) => {
        const masterMedication =
          resolveMasterMedication(medicationEntry?.name) ||
          resolveMasterMedication(selectedMedication)

        return (
          Boolean(medicationEntry?.specialtyMedication) ||
          Boolean(masterMedication?.specialtyMedication)
        )
      })

    if (!specialtyMedicationEntries.length) {
      return false
    }

    try {
      const { loginUserId, loginUsername } = getLoggedInUserDetails()
      const boardResponse = await SaveBoard('GET', null, 42)
      const parsedBoardResponse = typeof boardResponse?.d === 'string' ? JSON.parse(boardResponse.d) : boardResponse
      const statusRows = Array.isArray(parsedBoardResponse?.data?.[1]) ? parsedBoardResponse.data[1] : []
      const toDoStatus = [...statusRows]
        .sort((a, b) => Number(a?.order_index || 0) - Number(b?.order_index || 0))
        .find((status) => String(status?.StatusName || '').trim().toLowerCase() === 'to do')

      if (!toDoStatus?.StatusId) {
        console.error('Specialty medication board default status not found for board 42:', statusRows)
        toast.error('Medication added, but specialty medication board status could not be resolved.', toastConfig)
        return
      }

      const createdByLabel = [loginUsername, loginUserId].filter(Boolean).join(' - ')
      const resolvedPatientName = String(patientName || '').trim()
      const resolvedFacilityName = String(facilityName || '').trim()
      const resolvedRoomNumber = String(roomNumber || '').trim()
      const specialtyTaskTitle = resolvedPatientName
        ? `${resolvedPatientName} - Specialty Medication`
        : 'Specialty Medication'
      const specialtyTaskDescription = [
        resolvedRoomNumber ? `Room Number: ${resolvedRoomNumber}` : '',
        resolvedFacilityName ? `Facility: ${resolvedFacilityName}` : '',
        resolvedPatientName ? `Patient Name: ${resolvedPatientName}` : '',
      ]
        .filter(Boolean)
        .join('\n')
      const activityLog = {
        Id: Date.now(),
        Description: `Specialty medication task created for patient ${patientID}`,
        CreatedBy: loginUsername || createdByLabel || 'System',
        CreatedDate: new Date(),
      }

      const linkedMedicationPayload = specialtyMedicationEntries.reduce((acc, medicationEntry) => {
        const masterMedication =
          resolveMasterMedication(medicationEntry?.name) ||
          resolveMasterMedication(selectedMedication)
        const medicationName = String(medicationEntry?.name || '').trim()

        if (!medicationName) return acc
        if (acc.some((item) => String(item?.label || item?.name || '').trim().toLowerCase() === medicationName.toLowerCase())) {
          return acc
        }

        acc.push({
          ...medicationEntry,
          value: masterMedication?.id || masterMedication?.ID || medicationEntry?.id || medicationName,
          label: medicationName,
          specialtyMedication: true,
          patientName: resolvedPatientName,
          patientID: patientID || '',
          noteID: noteID || '',
          appoinmentDate: appoinmentDate || '',
          masterMedicationId: masterMedication?.id || masterMedication?.ID || '',
        })

        return acc
      }, [])

      if (!linkedMedicationPayload.length) {
        return false
      }

      const response = await SaveTasks({
        action: 'INSERT',
        taskId: '',
        boardId: 42,
        title: specialtyTaskTitle,
        description: specialtyTaskDescription,
        statusId: Number(toDoStatus.StatusId),
        status: 'To Do',
        priority: 'Medium',
        createdBy: loginUserId || '',
        CreatedBy: loginUserId || '',
        linkedMedicationsJson: JSON.stringify(linkedMedicationPayload),
        activityLogsJson: JSON.stringify([activityLog]),
        commentsJson: '[]',
        tagsJson: '[]',
        assignedUsersJson: loginUserId
          ? JSON.stringify([
              {
                UserId: loginUserId,
                Username: loginUsername || loginUserId,
                value: loginUserId,
                label: loginUsername || loginUserId,
              },
            ])
          : '[]',
        AssignedUsersJson: loginUserId
          ? JSON.stringify([
              {
                UserId: loginUserId,
                Username: loginUsername || loginUserId,
                value: loginUserId,
                label: loginUsername || loginUserId,
              },
            ])
          : '[]',
        subtasksJson: '[]',
        attachmentsJson: '[]',
      })

      const parsedResponse = typeof response?.d === 'string' ? JSON.parse(response.d) : response
      const createdTask =
        parsedResponse?.data?.[0] ||
        parsedResponse?.Data?.[0] ||
        response?.data?.[0] ||
        response?.Data?.[0]

      if (response?.error || parsedResponse?.error || !createdTask?.TaskId) {
        console.error('Failed to create specialty medication task:', response.error)
        toast.error('Medication added, but specialty medication task could not be created.', toastConfig)
        return false
      }

      toast.success('Task for Speciality Medication has been Created', toastConfig)
      return true
    } catch (error) {
      console.error('Error creating specialty medication task:', error)
      toast.error('Medication added, but specialty medication task could not be created.', toastConfig)
      return false
    }
  }

  const buildMedicationEntry = () => ({
    id: isEditMedicationAddedIndex ? isEditMedicationAddedIndex : Date.now(),
    name: selectedMedication?.name || selectedMedication,
    dosage: selectDosageName?.label,
    route: route ? route : '',
    intervations: selectedMedication?.drugIntervention,
    frequency: frequency ? frequency : '',
    sideeffect: selectedMedication?.sideeffect,
    diagnosis: selectedMedication?.diagnoses,
    date: new Date().toLocaleString(),
    standingTemplateName: selectedMedication?.standingTemplateName,
    specialtyMedication: Boolean(resolveMasterMedication(selectedMedication)?.specialtyMedication),
    iseditingList: isEditMedicationAddedIndex ? isEditMedicationAddedIndex : undefined,
    Diagnosis: selectedDiagnosis || [],
  })

  const getDiagnosisData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    const sortedOptions = data.Data.map((obj) => ({
      value: obj.id,
      label: obj.Name.trim(),
    })).sort((a, b) => a.label.localeCompare(b.label))

    setDiagnosisData(sortedOptions)
  }

  const separator = '-|-'
  const fetchMasterMedicationsOptions = async () => {
    let allMedicines = await MedicineCRUD('GET')
    let formattedData
    formattedData = JSON.parse(allMedicines.d)?.Data
    formattedData = formattedData.map((item) => {
      return {
        ...item,
        Data: JSON.parse(item.Data),
      }
    })
    if (formattedData) {
      formattedData = formattedData.map((item) => item.Data)
      const allMedications = formattedData.map((item) => ({
        label: `${item.name} / ${item.otherName}`,
        value: `${item.name}${separator}${item.dosage}${separator}${item.method}`,
      }))
      setMedicationOptions(allMedications)
      setAllMedications(formattedData)
    }
  }
  useEffect(() => {
    if (medicationName) {
      const { value, label } = medicationName

      let medication = value.split(separator)
      let [name, dosage, method] = medication
      // if (dosage) { setDosage(dosage); }
      // if (method) { setRoute(method) }
      setDosage(dosage)
      setRoute(method || route)
      const matchedMedication = allMedications.find((med) => med.name?.trim()?.toLowerCase() === name?.trim()?.toLowerCase())
      setSelectedMedication(matchedMedication || name || value || null)
    } else {
      setSelectedMedication(null)
    }
  }, [medicationName])

  useEffect(() => {
    getDiagnosisData()
    fetchMasterMedicationsOptions()
  }, [])

  const handleDeleteMedicationList = (customId) => {
    const updatedMedications = newMedications.filter((item, index) => item.id !== customId)
    setNewMedications(updatedMedications)
  }

  useEffect(() => {
    if (medicationName && newMedications.length > 0) {
      const { value, label } = medicationName
      let medication = value?.split('/') || []
      const [nameMedication, dosage] = value.split(separator)
      const allMedicationDrugToDrugAffected = newMedications
        .filter((item) => item.intervations && item.intervations.length > 0)
        .flatMap((item) =>
          item.intervations.map((intervention) => ({
            ...intervention,
            nameOfMedicine: item.name,
          })),
        )
        .filter((item) => item.medicationName === nameMedication)
      const uniqueMedicationsDrugs = Array.from(new Set(allMedicationDrugToDrugAffected.map((item) => JSON.stringify(item)))).map((item) => JSON.parse(item))
      setDrugIntervationsSelectedMedication(uniqueMedicationsDrugs)
    }
  }, [medicationName])

  const handleAddMedication = async () => {
    // if (!selectedMedication || !selectDosageName || !route || !frequency) {  removing the check of dosage and route as they are not mandatory fields 2 july 2025
    if (!selectedMedication) {
      toast.error('All the fields needs to be filled.', toastConfig)
      return
    }
    try {
      if (drugIntervationsSelectedMedication.length > 0) {
        setShowDrugIntervationsModal(true)
      } else {
        if (selectedMedication) {
          const newMedication = buildMedicationEntry()
          addMedicationToList(newMedication)
          if (newMedication?.specialtyMedication) {
            setPendingSpecialtyMedications((prev) => {
              const next = prev.filter((item) => item.id !== newMedication.id)
              next.push(newMedication)
              return next
            })
          }
          setMedicationName('')
          setDosage('')
          setRoute('')
          setFrequency('')
          setSelectedOption(null)
          setSelectedDosageName([])
          setSelectedDiagnosis([])
          setTextFile('')
          if (isEditMedicationAddedIndex) {
            setIsEditMedicationAddedIndex(null)
          }
        }
      }
    } catch (error) {
      console.log(error, 'error while adding the medications')
    }
  }

  const handleShowContinueAfterDrugIntervation = async () => {
    if (selectedMedication) {
      const newMedication = {
        ...buildMedicationEntry(),
        name: selectedMedication?.name || selectedMedication,
        dosage: selectDosageName?.label,
        route: route || '',
        intervations: selectedMedication?.drugIntervention,
        frequency: frequency || '',
        sideeffect: selectedMedication?.SideEffect || selectedMedication?.sideeffect,
        diagnosis: selectedMedication?.Diagnosis || selectedMedication?.diagnoses,
      }
      addMedicationToList(newMedication)
      if (newMedication?.specialtyMedication) {
        setPendingSpecialtyMedications((prev) => {
          const next = prev.filter((item) => item.id !== newMedication.id)
          next.push(newMedication)
          return next
        })
      }
      setMedicationName('')
      setDosage('')
      setRoute('')
      setFrequency('')
      setSelectedOption(null)
      setSelectedDiagnosis([])
      if (isEditMedicationAddedIndex) {
        setIsEditMedicationAddedIndex(null)
      }
    }
    setShowDrugIntervationsModal(false)
  }

  const handleOnCancelAddingMedicationDrugIntervated = () => {
    setMedicationName('')
    setDosage('')
    setRoute('')
    setFrequency('')
    setShowDrugIntervationsModal(false)
    setDrugIntervationsSelectedMedication([])
  }

  const handleEditPatientAddedMedication = (med) => {
    setIsEditMedicationAddedIndex(med.customId || med.id)
    const matchedMedication = allMedications.find((meds) => meds.name === med.name) || med.name

    const option = medicationOptions.find((option) => option.label === `${matchedMedication.name} / ${matchedMedication.otherName}`) || { value: `${med.name}${separator}${med.dosage}${separator}${med.route}`, label: med.name }
    setSelectedMedication(matchedMedication || null)
    const removeCurrentEditOptions = newMedications.filter((medic) => medic.id !== med.id)
    setNewMedications(removeCurrentEditOptions)
    setMedicationName(option)
    setDosage(med.dosage)
    setFrequency(med.frequency)
    setSelectedMedication(med)
    setSelectedOption(option)
    setSelectedDosageName({ label: med.dosage, value: med.dosage })
    setRoute(med.route)
    setSelectedDiagnosis(med?.Diagnosis || [])
  }

  const onResetForm = () => {
    setModalVisible(false)
    // setNewMedications([])
    setEditMedicationBundleListDateId(null)
    setDosage('')
    setRoute('')
    setFrequency('')
    setMedicationName(null)
    setSelectedOption(null)
    setIsEditMedicationAddedIndex(null)
    setDrugIntervationsSelectedMedication([])
    setModalVisible(false)
    setTextFile('')
    setPendingSpecialtyMedications([])
  }
  useEffect(() => {
    let dosageOptions = dosage?.split(',') || []
    dosageOptions = dosageOptions.map((item, idx) => ({ label: item, value: item }))
    setDosageOption(dosageOptions)
  }, [dosage])

  const handleCreateMedication = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue, selectedMedication: selectedMedication, new: true }
    // setAllMedications((prevOptions) => [...prevOptions, newOption]);
    // setMedicationOptions((prevOptions) => [...prevOptions, newOption])
    setSelectedOption(newOption)
    setMedicationName(newOption)
  }
  const handleCreateDosage = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue }
    setSelectedDosageName(newOption)
  }

  const handleCreateFrequency = (inputValue) => {
    const trimmedValue = inputValue.trim()
    if (!trimmedValue) return
    setFrequency(trimmedValue)
  }

  useEffect(() => {
    if (!Array.isArray(medicationList) || medicationList.length === 0) return
    if (editMedicationBundleListDateId) {
      if (medicationList.length > 1) {
        const medication = medicationList[1] || {}
        setCompareMedication(medication)

        // Optionally update new medications
        // if (medication?.data?.length > 0) {
        //     setNewMedications(medication.data);
        // }
      }
    } else {
      // Non-edit
      if (medicationList.length > 0) {
        const medication = medicationList[0] || {}
        setCompareMedication(medication)

        if (medication?.data?.length > 0) {
          setNewMedications(medication.data)
        }
      }
    }
  }, [medicationList, editMedicationBundleListDateId])

  const handleSubmitSubjective = async (summary) => {
    try {
      const noteKey = noteID || 0

      let data = {
        [patientID]: {
          [noteKey]: {
            HPI: {}, // Will be set conditionally
            medicationRemarksForSubjective: summary,
            data: 'Greater than 50% of the total time was spent on coordinating care, reviewing labs, imaging, and speaking with nursing and ancillary staff.',
          },
        },
      }

      const IsExisting = await fetchPatientFinalNoteDetails()

      const isValidObject = IsExisting && typeof IsExisting === 'object' && !Array.isArray(IsExisting) && Object.keys(IsExisting).length > 0 && IsExisting?.Id

      if (isValidObject) {
        // Extract and parse the JSON from IsExisting.JsonData
        let parsed = {}
        try {
          parsed = JSON.parse(IsExisting.JsonData || '{}')
        } catch (err) {
          console.error('Failed to parse existing JsonData:', err)
        }

        // Get HPI from existing data if present
        const existingHPI = parsed?.[patientID]?.[noteKey]?.HPI || {}

        // Inject existing HPI into new data
        data[patientID][noteKey].HPI = existingHPI

        await SaveExtra('Update', 'PatientHPI', JSON.stringify(data), IsExisting.Id)
      } else {
        // Insert new
        await SaveExtra('Insert', 'PatientHPI', JSON.stringify(data))
      }
    } catch (error) {
      console.error('Error in handleSubmitSubjective:', error)
    }
  }

  const handleCompareMedication = async () => {
    if (compareMedication?.data?.length > 0) {
      const continuedMeds = []
      const updatedMeds = []
      const discontinuedMeds = []
      const newlyAddedMeds = []

      newMedications.forEach((med) => {
        const original = compareMedication.data.find((item) => item.name === med.name)

        if (original) {
          const dosageChanged = original.dosage !== med.dosage
          const frequencyChanged = original.frequency !== med.frequency
          const routeChanged = original.route !== med.route

          if (dosageChanged || frequencyChanged || routeChanged) {
            const oldInfo = `${original.name} ${original.dosage} ${original.frequency} ${original.route || ''}`.replace(/\s+/g, ' ').trim()
            const newInfo = `${med.name} ${med.dosage} ${med.frequency} ${med.route || ''}`.replace(/\s+/g, ' ').trim()
            updatedMeds.push(`"${oldInfo}" to "${newInfo}"`)
          } else {
            if (!continuedMeds.includes(med.name)) {
              continuedMeds.push(med.name)
            }
          }
        } else {
          // New medication added
          if (!newlyAddedMeds.includes(med.name)) {
            newlyAddedMeds.push(med.name)
          }
        }
      })

      compareMedication.data.forEach((oldMed) => {
        const stillExists = newMedications.find((med) => med.name === oldMed.name)
        if (!stillExists) {
          discontinuedMeds.push(oldMed.name)
        }
      })

      const lastSeenDate = appoinmentDate?.split(' ')[0] || compareMedication.date?.split(' ')[0] || 'an unknown date'

      const continuedText = continuedMeds.length ? `Continued: ${continuedMeds.join(', ')}` : ''
      const updatedText = updatedMeds.length ? `Updated: ${updatedMeds.join(', ')}` : ''
      const newlyAddedText = newlyAddedMeds.length ? `Added: ${newlyAddedMeds.join(', ')}` : ''
      const discontinuedText = discontinuedMeds.length ? `Discontinued: ${discontinuedMeds.join(', ')}` : ''

      const summaryParts = [continuedText, updatedText, newlyAddedText, discontinuedText].filter(Boolean)
      const summary = `Patient was last seen on ${lastSeenDate}. ${summaryParts.join('. ')}.`

      await handleSubmitSubjective(summary)
      const saved = await handleSaveMedications()
      if (saved) {
        await createSpecialtyMedicationTask(pendingSpecialtyMedications)
        setPendingSpecialtyMedications([])
      }
      setTextFile('')
    } else {
      const saved = await handleSaveMedications()
      if (saved) {
        await createSpecialtyMedicationTask(pendingSpecialtyMedications)
        setPendingSpecialtyMedications([])
      }
      setTextFile('')
    }
  }

  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }

  const fetchPatientFinalNoteDetails = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      let allData = JSON.parse(data?.d)

      const allPatientHpiData = allData?.Data?.map((item) => {
        return {
          ...item,
          ...JSON.parse(item?.JsonData),
        }
      })

      const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
      return result
    } catch (error) {
      console.error(error)
    }
  }

  // useEffect(() => {
  //     fetchPatientFinalNoteDetails()
  // }, [])

  const inputValueRef = useRef(null)

  const extractText = (event) => {
    const input = event.target
    const file = input.files[0]
    if (!file) return

    pdfToText(file)
      .then((text) => {
        if (text !== '') {
          // setModalComparingFileTextVisible(true);
          setTextFile(text)
          // setAddingFile(false);
        }
      })
      .catch((error) => {
        console.error('Failed to extract text from PDF', error)
      })
      .finally(() => {
        // Reset input so the same file can be selected again
        //   input.value = "";
      })
  }

  return (
    <div className="mb-3">
      <CModal
        alignment="center"
        backdrop={'static'}
        className="patient-medication-modal"
        onClose={onResetForm}
        scrollable
        visible={Boolean(modalVisible)}
        size="xl"
      >
        <CModalHeader onClose={onResetForm}>
          <CModalTitle>{editMedicationBundleListDateId !== null ? 'Update Patient Medications' : 'Add Patient Medications'}</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            gap: '30px',
          }}
          className="d-flex"
        >
          {textFile && (
            <div
              style={{
                overflowY: 'auto',
                maxHeight: '500px',
              }}
              className="w-100"
            >
              <div
                className="p-2"
                style={{
                  width: '100%',
                  borderRadius: '12px',
                  border: '1px solid rgb(203, 203, 203)',
                  backgroundColor: '#eeeeee',
                }}
              >
                <div className="">
                  <HighlightedText text={textFile} keywords={Array.isArray(newMedications) ? newMedications.map((item) => item.name) : []} />
                </div>
              </div>
            </div>
          )}

          <div
            className="w-100"
            style={{
              overflowY: 'auto',
              maxHeight: '500px',
            }}
          >
            <div>
              <CFormLabel>Medication Name</CFormLabel>
              {/* <Select
                            isClearable
                            value={selectedOption}
                            onChange={(option) => {
                                setSelectedOption(option);
                                setMedicationName(option);
                            }}
                            options={medicationOptions}
                        /> */}
              <CreatableSelect
                isClearable
                value={selectedOption}
                onChange={(option) => {
                  setSelectedOption(option)
                  setMedicationName(option)
                }}
                onCreateOption={handleCreateMedication}
                options={medicationOptions}
                className="react-select-container"
                classNamePrefix="react-select"
              />
              {selectedMedication && (
                <div className="mt-1">
                  <CFormLabel className="text-warning">
                    <b>Mechanism of Action:</b> {selectedMedication.mechanismOfAction}{' '}
                  </CFormLabel>
                  <CFormLabel className="text-warning" style={{ marginLeft: '10px', marginRight: '10px' }}>
                    <b>Medication Class:</b> {selectedMedication.class}{' '}
                  </CFormLabel>
                  <CFormLabel className="text-warning">
                    {' '}
                    <b> Route :</b> {selectedMedication.method}{' '}
                  </CFormLabel>
                  <CFormLabel className="text-warning">
                    <b> Side Effect:</b> {selectedMedication.sideEffect !== '' ? selectedMedication.sideEffect : 'None'}
                  </CFormLabel>
                  <br />
                  {selectedMedication.alerts && (
                    <CFormLabel className="text-warning">
                      <b>Alerts:</b> {selectedMedication.alerts !== '' ? selectedMedication.alerts : 'None'}
                    </CFormLabel>
                  )}
                </div>
              )}
              {(selectedOption?.new || selectedDiagnosis.length > 0) && (
                <div className="mt-2">
                  <CFormLabel className="">Diagnosis</CFormLabel>
                  <Select
                    isClearable
                    value={selectedDiagnosis}
                    onChange={(option) => {
                      setSelectedDiagnosis(option)
                    }}
                    options={diagnosisData}
                    isMulti={true}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
              )}
            </div>
            <CFormLabel className="mt-3">Dosage</CFormLabel>
            {/* <CFormInput type="text" value={dosage} onChange={(e) => setDosage(e.target.value)} /> */}
            {/* <Select
                        isClearable
                        value={selectDosageName}
                        onChange={(option) => {
                            setSelectedDosageName(option);
                        }}
                        options={dosageOption}
                    /> */}
            <CreatableSelect
              isClearable
              value={selectDosageName}
              onChange={(option) => {
                setSelectedDosageName(option)
              }}
              onCreateOption={handleCreateDosage}
              options={dosageOption}
              className="react-select-container"
              classNamePrefix="react-select"
            />

            <CFormLabel className="mt-3">Route</CFormLabel>
            <CFormInput type="text" value={route} onChange={(e) => setRoute(e.target.value)} />

            <CFormLabel className="mt-3">Frequency</CFormLabel>
            <CreatableSelect
              isClearable
              value={frequency ? { value: frequency, label: frequency } : null}
              onChange={(option) => {
                setFrequency(option?.value || '')
              }}
              onCreateOption={handleCreateFrequency}
              options={frequencyMedicationOptions}
              styles={selectMenuStyles}
              className="react-select-container"
              classNamePrefix="react-select"
            />

            <CButton
              className="mt-3"
              onClick={handleAddMedication}
              style={{ backgroundColor: 'var(--ui-color-primary, #2b7cd3)', borderColor: 'var(--ui-color-primary, #2b7cd3)', color: '#fff' }}
            >
              {isEditMedicationAddedIndex ? 'Update Medication' : 'Add Medication'}
            </CButton>

            <div className=" ">
              <CTable className="mt-3">
                <div>
                  <CTableHead>
                    <CTableRow style={{ position: 'sticky', top: '0', backgroundColor: 'var(--ui-dashboard-surface-2, #1b1b1b)', zIndex: '1' }}>
                      <CTableHeaderCell style={{ width: '40%', fontWeight: '400' }}>Medication Name</CTableHeaderCell>
                      <CTableHeaderCell style={{ width: '30%', fontWeight: '400' }}>Dosage</CTableHeaderCell>
                      <CTableHeaderCell style={{ width: '10%', fontWeight: '400' }}>Route</CTableHeaderCell>
                      <CTableHeaderCell style={{ width: '20%', fontWeight: '400' }}>Frequency</CTableHeaderCell>
                      <CTableHeaderCell style={{ width: '20%', fontWeight: '400' }}>Action</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {newMedications.map((med, index) => (
                      <CTableRow key={index} className="" style={{ width: '100%' }}>
                        <CTableDataCell valign="middle" style={{ width: '40%' }}>
                          {med.name}
                        </CTableDataCell>
                        <CTableDataCell valign="middle" style={{ width: '30%' }}>
                          {med.dosage}
                        </CTableDataCell>
                        <CTableDataCell valign="middle" style={{ width: '10%' }}>
                          {med.route}
                        </CTableDataCell>
                        <CTableDataCell valign="middle" style={{ width: '20%' }}>
                          {med.frequency}
                        </CTableDataCell>
                        <CTableDataCell valign="middle" style={{ width: '20%', padding: '10px' }} className="d-flex gap-2">
                          {/* <CButton
                                                    variant='outline'
                                                    color="warning"
                                                    onClick={() => { handleEditPatientAddedMedication(med); }}
                                                    className='warning py-1 px-3'>
                                                    Edit
                                                </CButton>
                                                <CButton
                                                    variant='outline'

                                                    color="danger"
                                                    onClick={() => { handleDeleteMedicationList(med.id); }}
                                                    className='danger py-1 px-3'>
                                                    Delete
                                                </CButton> */}
                          <CDropdown alignment={'end'}>
                            <CDropdownToggle
                              variant="ghost"
                              className="border-0 p-0 medication-actions-toggle"
                              style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
                              aria-label="Medication row actions"
                            >
                              <EllipsisVertical className="medication-actions-icon" />
                            </CDropdownToggle>
                            <CDropdownMenu>
                              <CDropdownItem
                                onClick={() => {
                                  handleEditPatientAddedMedication(med)
                                }}
                              >
                                Edit
                              </CDropdownItem>
                              <CDropdownItem
                                onClick={() => {
                                  handleDeleteMedicationList(med.id)
                                }}
                              >
                                Delete
                              </CDropdownItem>
                            </CDropdownMenu>
                          </CDropdown>
                        </CTableDataCell>
                      </CTableRow>
                    ))}
                  </CTableBody>
                </div>
              </CTable>
            </div>
          </div>
        </CModalBody>
        <CModalFooter
          style={{
            position: 'sticky',
            bottom: '0',
            backgroundColor: 'white',
            width: '100%',
            borderRadius: '0 0 16px 16px',
          }}
          className="border-0"
        >
          {/* <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              setAddingFile(true)
            }}
          >
            Upload File
          </CButton> */}
          <CButton
            onClick={handleCompareMedication}
            style={{ backgroundColor: 'var(--ui-color-primary, #2b7cd3)', borderColor: 'var(--ui-color-primary, #2b7cd3)', color: '#fff' }}
          >
            {editMedicationBundleListDateId ? 'Update Medications' : 'Save Medications'}
          </CButton>
          <CButton
            variant="outline"
            color="secondary"
            onClick={() => {
              onResetForm()
              setNewMedications([])
            }}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal className="handleOnCancelAddingMedicationDrugIntervatedModal" backdrop="static" alignment="center" focus visible={showDrugIntervationsModal} size="lg" onClose={handleOnCancelAddingMedicationDrugIntervated}>
        <CModalHeader>
          <CModalTitle id="StaticBackdropExampleLabel">Drug to Drug Intervation</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CTable>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell scope="col">#</CTableHeaderCell>
                <CTableHeaderCell scope="col">Medication Name</CTableHeaderCell>
                <CTableHeaderCell scope="col">Note</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {drugIntervationsSelectedMedication.map((item, i) => (
                <CTableRow key={i}>
                  <CTableHeaderCell scope="row">{i + 1}</CTableHeaderCell>
                  <CTableDataCell>{item.nameOfMedicine}</CTableDataCell>
                  <CTableDataCell>{item.note}</CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
        </CModalBody>
        <CModalFooter>
          <CButton onClick={handleShowContinueAfterDrugIntervation} color="primary">
            Continue
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal
        className="handleOnCancelAddingMedicationDrugIntervatedModal"
        backdrop="static"
        alignment="center"
        focus
        visible={addingFile}
        size="lg"
        onClose={() => {
          setAddingFile(false)
        }}
      >
        <CModalHeader>
          <CModalTitle id="StaticBackdropExampleLabel">Upload file to detect Medications</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div style={{}} variant="outline" color="primary" className="d-flex align-items-center gap-2 ">
            <div className="mb-3">
              <CFormInput ref={inputValueRef} id="formFileMultiple" label="Multiple files input example" accept="application/pdf" type="file" onChange={extractText} />
            </div>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            variant="outline"
            onClick={() => {
              handleAddDetectedToMedListInModal()
              setAddingFile(false)
              inputValueRef.current.value = ''
            }}
            color="primary"
          >
            Continue
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default AddMedicationForm
